import { render, staticRenderFns } from "./NotAffected.vue?vue&type=template&id=15a83a00"
import script from "./NotAffected.vue?vue&type=script&lang=js"
export * from "./NotAffected.vue?vue&type=script&lang=js"
import style0 from "./NotAffected.vue?vue&type=style&index=0&id=15a83a00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports